module.exports = __webpack_public_path__ + "img/ddd40bc.png";